import { Cache } from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';

Cache.enabled = true;
export const fbxLoader = new FBXLoader();

console.log('[fbx loader] enable cache');
